import React from 'react'
import { Box, Typography, TextField, Button } from '@mui/material'
import AnalyticsIcon from '@mui/icons-material/Analytics'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

export interface WizardStep0WelcomeProps {
  title: string
  onTitleChange: (title: string) => void
  onNext: () => void
}

/** Step 0 — full-orientation welcome + title (#970 Part A). */
export const WizardStep0Welcome: React.FC<WizardStep0WelcomeProps> = ({ title, onTitleChange, onNext }) => (
  <Box
    sx={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: 3,
      p: 4,
      maxWidth: 560,
      mx: 'auto',
    }}
  >
    <AnalyticsIcon color="info" sx={{ fontSize: 48 }} />
    <Typography variant="h6" fontWeight={700}>Gen AI Insights</Typography>
    <Typography variant="body2" color="text.secondary">
      Gen AI Insights generates written analysis based on the data sources and instructions you give it.
      It can reference tables and files, and can be regenerated whenever your data updates.
      To get started, give this insight a title.
    </Typography>
    <TextField
      fullWidth
      autoFocus
      label="Title"
      placeholder="e.g. Sky TV Spontaneous Awareness"
      value={title}
      onChange={(e) => onTitleChange(e.target.value)}
      onKeyDown={(e) => { if (e.key === 'Enter' && title.trim()) onNext() }}
    />
    <Button
      variant="contained"
      color="info"
      size="large"
      endIcon={<ArrowForwardIcon />}
      disabled={!title.trim()}
      onClick={onNext}
    >
      Let&apos;s go
    </Button>
  </Box>
)

export default WizardStep0Welcome
